import React, {useRef} from 'react'
import Header from './components/header/header.jsx'
import Footer from './components/footer/footer.jsx'
import {ThemeProvider, useTheme} from '@mui/material/styles'
import FloatingContact from './components/floatingContact/floatingContact.jsx';
import BodyPage from './components/body/bodyPage.jsx';

const App = () => {
  const theme = useTheme();
  const clinicInfoRef = useRef(null)
  const priceInfoRef = useRef(null)
  const contactRef = useRef(null)

  return (
    <ThemeProvider theme={theme}>
      <Header clinicInfoRef={clinicInfoRef} priceInfoRef={priceInfoRef} contactRef={contactRef}/>
      <BodyPage clinicInfoRef={clinicInfoRef} priceInfoRef={priceInfoRef} contactRef={contactRef}/>
      <FloatingContact />
      <Footer />
    </ThemeProvider>
  )
}

export default App
